var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locations-map"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"id":"map","title":"locations","src":_vm.src,"width":"100%","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }